import { Button } from '@casavo/base-ui'
import cn from 'classnames'

import Close from '@/components/Icon/Close'
import { useModal } from '@/context/ModalContext'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { zIndex } from '@/utils/css-utils'

import { modalBase } from './styles.css'

export const ModalBase: React.FC<{
  backToInitialScroll?: boolean
  className?: string
  handleClose?: VoidFunction
  noPadding?: boolean
}> = ({ backToInitialScroll, children, className, handleClose, noPadding }) => {
  const { closeModal } = useModal()
  return (
    <div className={cn(modalBase, className)} style={{ padding: noPadding && 0 }}>
      <Button
        ariaLabel="Close"
        className={sprinkles({ position: 'absolute', right: 'm', top: 'm', zIndex: zIndex('modalContent') })}
        Icon={(props) => <Close {...props} />}
        shapeVariant="round"
        styleVariant="tertiary"
        onClick={() => {
          closeModal({ shouldBackToInitialScroll: backToInitialScroll })
          handleClose && handleClose()
        }}
      />
      {children}
    </div>
  )
}
